var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allStudentTags.length>0)?_c('div',[_c('div',{staticClass:"header-title",staticStyle:{"margin-bottom":"20px"}},[_vm._v("学生评价")]),_vm._v(" "),_c('student-tag-cascader',{ref:"allStudentTagRef",attrs:{"disabled":"","selectedTags":_vm.allStudentTags,"border":""}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c878a3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/record/student-tag/record-all-tags.vue
// module id = J+HI
// module chunks = 17 21